import { useGetRecommendations } from '@/api/recommendation/recommendation.hooks';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { AddRecommendation } from './AddRecommendation';
import { RecommendationCard } from './RecommendationCard';

export const RecommendationManagement = () => {
  const { recommendations, isLoading, isError, refetch } =
    useGetRecommendations();

  if (isLoading) return <LoadingScreen />;
  if (isError) return <ErrorScreen />;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <p className="text-sm text-zinc-500">
          {recommendations.length} recommandation
          {recommendations.length !== 1 ? 's' : ''}
        </p>
        <AddRecommendation refetch={refetch} />
      </div>

      {recommendations.length === 0 ? (
        <p className="text-gray-500 text-center mt-12">
          Aucune recommandation pour le moment.
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {recommendations.map((item) => (
            <RecommendationCard key={item.id} item={item} refetch={refetch} />
          ))}
        </div>
      )}
    </div>
  );
};
